import Queries from '../../../utils/API/Queries';
import { showErrorMessage } from '../../../redux/store/Control';

class CreatePartnerPackageModalHelper {
	static isPackageValid = (options, price?: number, name?: string) => {
		if (!name || name.length < 2) {
			return 'Please enter a package name.';
		} else if (!price) {
			return 'Please enter a package price.';
		} else if (options.length === 0) {
			return 'Please select some package options.';
		}
		return true;
	};
	static removeOption = (optionId, setOptions, options) => {
		setOptions(
			options.filter((item) => {
				return item.id !== optionId;
			})
		);
	};
	static editPackage = async (partners, client, onCreateFinished, selectedRegion, setUpdatedRegion) => {
		let regionToUpdate = selectedRegion;
		let variables = {
			id: regionToUpdate.regionConfig.id,
			coldwellPackages: {
				...regionToUpdate.regionConfig.coldwellPackages,
				partners
			}
		};
		const response = await client
			.mutate({
				mutation: Queries.UPDATE_REGION_CONFIG,
				variables
			})
			.catch((error) => {
				showErrorMessage(error.message);
			});
		const { updateRegionConfig } = response['data'];
		if (updateRegionConfig) {
			regionToUpdate.regionConfig = updateRegionConfig;
			setUpdatedRegion(regionToUpdate);
			onCreateFinished();
		} else {
			showErrorMessage('Error updating packages!');
		}
	};
	static updatePackage = async (deletePackage, client, onCreateFinished, partner, name, price, options, selectedRegion, packageToEdit, setUpdatedRegion) => {
		const { regionConfig } = selectedRegion;

		const { partners: partnersArray = [] } = regionConfig.coldwellPackages;
		const unchangedPartners = partnersArray.filter((filterPartner) => filterPartner.name !== partner.name);
		let matchingPartner = partnersArray.filter((filterPartner) => filterPartner.name === partner.name)[0];
		const unchangedPartnerPackage = matchingPartner.packages.filter((filterPackage) => filterPackage.name !== partner.name);
		let partners;

		if (packageToEdit) {
			const unchangedEditPartnerPackage = matchingPartner.packages.filter((filterPackage) => filterPackage.name !== packageToEdit.name);
			if (deletePackage === true) {
				matchingPartner.packages = [...unchangedEditPartnerPackage];
				partners = [...unchangedPartners, matchingPartner];
				await CreatePartnerPackageModalHelper.editPackage(partners, client, onCreateFinished, selectedRegion, setUpdatedRegion);
			} else {
				matchingPartner.packages = [
					...unchangedEditPartnerPackage,
					{
						name,
						price,
						options
					}
				];
				partners = [...unchangedPartners, matchingPartner];
				await CreatePartnerPackageModalHelper.editPackage(partners, client, onCreateFinished, selectedRegion, setUpdatedRegion);
			}
		} else {
			matchingPartner.packages = [
				...unchangedPartnerPackage,
				{
					name,
					price,
					options
				}
			];
			partners = [...unchangedPartners, matchingPartner];
			await CreatePartnerPackageModalHelper.editPackage(partners, client, onCreateFinished, selectedRegion, setUpdatedRegion);
		}
	};
}

export default CreatePartnerPackageModalHelper;
